import React, { useContext, useState } from 'react';
import { Formik } from 'formik';
import { Button, Container, Form, Spinner } from 'react-bootstrap';

import { AuthContext } from '../../contexts/AuthContext';
import { ToastContext } from '../../contexts/ToastContext';

import logo from '../../assets/logo.svg';
import './signin.css';

import CopyrightNotice from '../../components/helper/CopyrightNotice';

const Login = () => {
  const {
    // Auth0
    user, isAuthenticated, isLoading,
    // API
    apiUser, isAPIAuthenticated,
  } = useContext(AuthContext);
  const { toast } = useContext(ToastContext);

  const [loading, setLoading] = useState(false);

  const renderForm = () => {

    const onSuccess = async (values) => {
      console.log(apiUser);
      setLoading(true);
      try {

        setLoading(false);
      } catch (err) {
        //console.log(err);
        toast('Reset Error!');
        setLoading(false);
      }
    };

    return (
      <div className="d-flex align-items-center flex-column justify-content-center" style={{ height: '100vh' }}>
        <div className="text-center w-100">
          <Formik
            onSubmit={onSuccess}
          >
            {({ handleSubmit, handleChange, values, touched, errors }) => {
              return (
                <Form className="form-signin" noValidate>
                  <img src={logo} alt="Fortress" width="300" height="130"></img>

                  <Button
                    className="btn btn-lg btn-primary btn-block"
                    variant="primary"
                    disabled={loading}
                    type="submit"
                  >
                    {loading ? (
                      <Spinner
                        as="span"
                        animation="grow"
                        role="status"
                        aria-hidden="true"
                      ></Spinner>
                    ) : (
                      'Get Password Reset Email'
                    )}
                  </Button>
                </Form>
              );
            }}
          </Formik>
        </div>

        <CopyrightNotice />
      </div>
    );
  };

  return <Container fluid>{renderForm()}</Container>;
};

export default Login;
